import { http } from '@4beefopag/4bee-fopag-core/dist/services';
import axios from 'axios';

export const upload = (file, requisicao) => {
  const formData = new FormData();
  formData.append('file', file);

  return http.post('arquivo/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      idRequisicao: requisicao.id,
    },
  });
};

export const removeUplodadedFile = (id) => http.post(`arquivo/remove/upload/${id}`);

export const viewUploadFile = (id) => http.get(`arquivo/view/upload/${id}`);

export const getPublicUrlsByRequisicao = (requisaoId) => http.get(`arquivo/requisicao/${requisaoId}/links`);

export const downloadFile = (nome, urlDownload) => {
  axios({
    url: urlDownload,
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nome);
    document.body.appendChild(link);
    link.click();
    link.remove();
  });
};
